import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	({ spacing }) => ({
		container: {
			paddingTop: spacing(1),
			paddingBottom: spacing(1),
		},
	}),
	{ name: 'Footer-Footer1' },
)

export default useStyles
